import React, { useState } from "react";
import { Button } from "../components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import { UserCircle } from "lucide-react";
import { useRecoilValue } from "recoil";
import { userState } from "../common/atom/userState";
import SessionUpdateBtn from "../components/SessionUpdateBtn";
import { useLogout } from "../common/logout";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const NavDesktop = () => {
  const user = useRecoilValue(userState) ?? {};
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const navigate = useNavigate();
  const logout = useLogout();
  const unifierUrl = process.env.REACT_APP_UNIFIER_URL;

  const handleLogout = () => {
    Swal.fire({
      icon: "info",
      title: "로그아웃 하시겠습니까?",
      showCancelButton: true,
      confirmButtonText: "로그아웃",
      cancelButtonText: "취소",
    }).then((result) => {
      if (result.isConfirmed) logout();
    });
  };

  return (
    <div className="app-header-box">
      <div className="app-header-right-box">
        <img
          alt="Logo"
          src="/images/g1313.png"
          className="h-8 w-auto"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/loa/all")}
        />
      </div>
      {/* Button Section */}
      <div className="app-header-button-box">
        <Button
          variant="outline"
          size="sm"
          asChild
          className="whitespace-nowrap rounded-md border-[#e4e4e7] text-[13px] font-semibold text-[#18181b] hover:border-[#d4d4d8] hover:bg-[#fafafa]"
        >
          <a
            href={unifierUrl || "#"}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => {
              if (!unifierUrl) e.preventDefault();
            }}
          >
            유니파이어 바로가기
          </a>
        </Button>
        <SessionUpdateBtn />
        <DropdownMenu
          open={userMenuOpen}
          onOpenChange={setUserMenuOpen}
          modal={false}
        >
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="text-[#3f3f46]">
              <UserCircle className="!size-[26px]" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            sideOffset={8}
            className="min-w-[200px]"
            onCloseAutoFocus={(e) => {
              if (document.querySelector(".swal2-container")) {
                e.preventDefault();
              }
            }}
          >
            <div className="flex items-center gap-2.5 px-4 py-3 pointer-events-none">
              <UserCircle className="size-10 text-[#98a2b3]" />
              <div>
                <p className="text-[15px] font-bold">
                  {user.name || user.username || "-"}
                </p>
                {user.name && user.username && (
                  <p className="text-xs text-muted-foreground">
                    {user.username}
                  </p>
                )}
              </div>
            </div>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={() => {
                setUserMenuOpen(false);
                handleLogout();
              }}
              className="gap-1 text-destructive focus:text-destructive"
            >
              로그아웃
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};

export default React.memo(NavDesktop);
